import { createSlice } from '@reduxjs/toolkit'
import { fetchInitContext, fetchResApproval } from './thunks'
import { updateCurrentlyEditing, updateEndDate, updateStartDate } from './resEditFormSlice'
import type { ApprovalRes } from './types'
import { updateBusiness } from './contextDropDownsSlice'
import { resetLocationTimeValues } from './resLocationsSlice'
export interface ResApprovalState {
	response?: Partial<ApprovalRes>
	approvalRequired: boolean
	startDateParsed: number | null
	endDateParsed: number | null
	numDays: number
	init: boolean
}

const initialState: ResApprovalState = {
	approvalRequired: false,
	response: null,
	endDateParsed: null,
	startDateParsed: null,
	numDays: 0,
	init: true,
}

export const resApprovalSlice = createSlice({
	name: 'resApproval',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(resetLocationTimeValues, state => {
			state.endDateParsed = null
			state.startDateParsed = null
			state.numDays = 0
		})
		builder.addCase(updateBusiness, state => {
			if (state.init === true) {
				state.init = false
			}
		})
		builder.addCase(updateStartDate, (state, action) => {
			if (action.payload.StartDate && action.payload.StartTime) {
				const d = new Date(action.payload.StartDate)
				const [hours, minutes] = action.payload.StartTime.split(':')
				d.setHours(Number(hours))
				d.setMinutes(Number(minutes))
				const parsed = Date.parse(d.toString())
				state.startDateParsed = parsed
			}
		})
		builder.addCase(updateEndDate, (state, action) => {
			if (action.payload.EndDate && action.payload.EndTime) {
				const d = new Date(action.payload.EndDate)
				const [hours, minutes] = action.payload.EndTime.split(':')
				d.setHours(Number(hours))
				d.setMinutes(Number(minutes))
				const parsed = Date.parse(d.toString())
				state.endDateParsed = parsed
				if (parsed && state.startDateParsed) {
					const sub = parsed - state.startDateParsed
					state.numDays = Math.ceil(sub / (1000 * 60 * 60 * 24))
				}
			}
		})
		builder.addCase(fetchResApproval.fulfilled, (state, action) => {
			if (action.payload?.success === 1) {
				const contactIds = action.payload.contactIds.map(function addKeyToContacts(contact) {
					return { ...contact, key: contact.id }
				})
				state.response = { ...action.payload, contactIds }
				state.approvalRequired = true
			}
		})
		builder.addCase(fetchInitContext.fulfilled, (state, action) => {
			if (action.payload?.approvals?.success === 1) {
				state.response = action.payload.approvals
				state.approvalRequired = true
			}
		})
		builder.addCase(updateCurrentlyEditing, (_, action) => {
			if (action.payload === false) {
				return initialState
			}
		})
	},
})

export const selectResApproval = state => state.resApproval

export const resApprovalSliceReducer = resApprovalSlice.reducer
